import { Box, Grid, useMediaQuery, useTheme } from '@material-ui/core';
import messages from 'components/MyContractInfo/AMCContractInfo/messages';
import {
  StyledCaption,
  StyledPaper,
  StyledShortBody,
} from 'components/MyContractInfo/styles';
import { get } from 'lodash';
import React, { ReactNode } from 'react';
import { injectIntl, IntlShape, useIntl } from 'react-intl';

interface ContractItemProps {
  label: string;
  value: string | ReactNode;
  isLong?: boolean;
}
const ContractItem = ({ value, label, isLong }: ContractItemProps) => {
  const { formatMessage } = useIntl();

  return (
    <Grid item sm={6} md={6}>
      <Grid container direction="column">
        <Grid item>
          <StyledCaption>{formatMessage(get(messages, label))}</StyledCaption>
        </Grid>
        <Grid item sm={isLong ? 8 : 12}>
          <Box marginBottom={2}>
            {typeof value === 'string' ? (
              <StyledShortBody>{value}</StyledShortBody>
            ) : (
              value
            )}
          </Box>
        </Grid>
      </Grid>
    </Grid>
  );
};

export interface AMCContractInfoType {
  intl: IntlShape;
  identification: string;
  souscripteur: string;
  name: string;
}
const AMCContractInfo = (props: AMCContractInfoType) => {
  const { identification, souscripteur, name } = props;

  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down('xs'));
  const parentDirection = matches ? 'row' : 'column';
  const childDirection = matches ? 'column' : 'row';

  return (
    <StyledPaper>
      <Box padding={2}>
        <Grid justify="space-between" direction={parentDirection}>
          <Grid item xs={12} sm={12}>
            <Grid container direction={childDirection}>
              <ContractItem label="nomPolice" value={souscripteur} />
            </Grid>
          </Grid>
          <Grid item xs={12} sm={12}>
            <Grid container direction={childDirection}>
              <ContractItem label="name" value={name} />
              <ContractItem label="identification" value={identification} />
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </StyledPaper>
  );
};

export default injectIntl(AMCContractInfo);
